<template>
  <div>
    <el-dialog 
      :title="`課程名稱:${courseTitle}`"
      :visible.sync="dialogTimeVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-form label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="8">
              <el-button type="primary" @click="addTimeRow()">新增時間</el-button>
            </el-col>
            <el-col :span="8">
              <span style="margin-left: 10px;">Time Zone: {{ timezone }}</span>
            </el-col>
            <el-col :span="8" align="right">
              <el-button type="success" @click="onSaveAll()">儲存所有</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div class="card-based">
        <el-card v-for="(lessonItem, index) in list" v-bind:key="lessonItem.id">
          <div slot="header" class="clearfix">
            <span>堂數: {{ index + 1 }}</span>
            <el-button style="float: right; padding: 3px 0"  v-if="lessonItem.timeStatus==='not_started'" type="danger" size="small" @click="onDeleteTime(index, lessonItem.id)">刪除</el-button>
          </div>
          <div>
            <label>開始日期時間</label>
            <el-date-picker
                v-model="lessonItem.beginTime"
                style="width:100%;"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="開始日期時間"
                value-format="yyyy-MM-dd HH:mm"
              />
          </div>
          <div>
            <label>結束日期時間</label>
            <el-date-picker
                v-model="lessonItem.endTime"
                style="width:100%;"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="結束日期時間"
                value-format="yyyy-MM-dd HH:mm"
              />
          </div>
          <div>  
            <label>Zoom</label>
            <el-select v-model="lessonItem.roomId">
                <el-option
                  v-for="item in roomOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
          </div>
          <div>
            <label>狀態</label>
            <el-select v-model="lessonItem.timeStatus">
                <el-option
                  v-for="item in lessonStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
          </div>
        </el-card>
      </div>

      <div class="list-based">
        <el-table
          ref="dragTable"
          :data="list"
          border
          fit
          highlight-current-row
          row-key="id"
          style="width:100%;height:300px;margin-top:30px;overflow-y:scroll;"
          >
          <el-table-column align="center" label="No" :min-width="10">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="開始日期時間" :min-width="20">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.beginTime"
                style="width:100%;"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="開始日期時間"
                value-format="yyyy-MM-dd HH:mm"
              />
            </template>
          </el-table-column>
          <el-table-column align="center" label="結束日期時間" :min-width="20">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.endTime"
                style="width:100%;"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="結束日期時間"
                value-format="yyyy-MM-dd HH:mm"
              />
            </template>
          </el-table-column>
          <el-table-column align="center" label="Zoom"  :min-width="20">
            <template slot-scope="scope">
              <el-select v-model="scope.row.roomId">
                <el-option
                  v-for="item in roomOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="狀態"  :min-width="15">
            <template slot-scope="scope">
              <el-select v-model="scope.row.timeStatus">
                <el-option
                  v-for="item in lessonStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="動作"  :min-width="15">
            <template slot-scope="scope">
              <el-button v-if="scope.row.timeStatus==='not_started'" type="danger" size="small" @click="onDeleteTime(scope.$index, scope.row.id)">刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.el-card {
  margin-top: 5px;
  margin-bottom: 5px;
}
.el-card div {
  margin-bottom: 5px;
}
@media (max-width: 800px) {
  .card-based {
    display: block;
  }
  .list-based {
    display: none;
  }
}
@media (min-width: 800px) {
  .card-based {
    display: none;
  }
  .list-based {
    display: block;
  }
}

</style>


<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import EventResource from '@/api/event'
const eventResource = new EventResource()

export default {
  name: 'TimeDialog',
  props: {
    dialogTimeVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      lessonId: 0,
      lessonNumber: '',
      courseTitle: '',
      list: [],
      newId: -1,
      roomOptions: [],
      lessonStatusOptions: [
        { 'value': 'not_started', 'label': '未上課' },
        { 'value': 'finished', 'label': '已完課' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'timezone'
    ])
  },
  methods: {
    open() {
      const roomOptions = [{ id: 0, name: '未選擇' }]
      this.$parent.roomOptions.forEach(function(item) {
        roomOptions.push({ id: item.id, name: item.zoomId })
      })
      this.roomOptions = roomOptions
      this.lessonId = this.$parent.currentTimeListLessonId
      this.lessonNumber = this.$parent.currentTimeListLessonNumber
      this.courseTitle = this.$parent.currentTimeListCourseTitle
      this.list = this.$parent.currentTimeListData
      // this.$nextTick(() => {
      //   this.setSort()
      // })
    },
    addTimeRow() {
      this.list.push({ id: this.newId, beginTime: '', endTime: '', roomId: 0, timeStatus: 'not_started' })
      this.newId = this.newId - 1
    },
    onDeleteTime(index, id) {
      this.$confirm('確定刪除 ?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        this.sendDelete(index, id)
      }).catch(() => {
        return false
      })
    },
    async sendDelete(index, id) {
      // console.log(id)
      if (id > 0) {
        const { data } = await eventResource.deleteLessonTimes(id)
        // console.log(data)
        if (data.code === 0) {
          this.list.splice(index, 1)
        } else {
          this.$parent.messageNotify(
            '刪除課堂時間失敗',
            data.errors,
            'error'
          )
          return false
        }
      } else {
        this.list.splice(index, 1)
      }
    },
    async sendSave() {
      const { data } = await eventResource.updateLessonTimes(this.list, this.lessonId)
      const actionTitle = 'Save Lesson Times '
      if (data.code === 0) {
        this.$parent.dialogTimeVisible = false
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
        this.$parent.getList()
      } else {
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          data.errors,
          'error'
        )
        return false
      }
    },
    onSaveAll() {
      this.$confirm('確定儲存更新 ? 課堂編號: ' + this.lessonNumber, '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '再想想'
      }).then(() => {
        this.sendSave()
      }).catch(() => {
        return false
      })
    },
    handleClose(done) {
      this.list = null
      this.lessonId = 0
      this.lessonNumber = ''
      this.courseTitle = ''
      this.$parent.dialogTimeVisible = false
      this.newId = -1
      this.roomOptions = null
      this.$parent.getList()
    },
    idWithLang({ name, id }) {
      return `${name}`
    },
    setSort() {
      const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, targetRow)
        }
      })
    }
  }
}
</script>
